<p-accordion [pt]="AccordionMonoPT" value="0" [multiple]="true" *transloco="let t; prefix: 'Gdpr'">
    <p-accordion-panel value="0">
        <p-accordion-header>{{ t('PrivacyPolicy') }}</p-accordion-header>
        <p-accordion-content>
            {{ t('PrivacyPolicyContent') }}
            <a [href]="contactUsUrl">{{ t('ContactUs') }}</a>
            .
            <br />
            {{ t('ComprehensivePrivacyPolicy') }}
            <br />
            <a [href]="privacyPolicyUrl">{{ privacyPolicyUrl }}</a>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="1">
        <p-accordion-header>{{ t('WhatConstitutesPersonalInfo') }}</p-accordion-header>
        <p-accordion-content>
            <p>
                {{ t('WhatConstitutesPersonalInfoContent') }}
            </p>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="2">
        <p-accordion-header>{{ t('HowIsPersonalInfoUtilized') }}</p-accordion-header>
        <p-accordion-content>
            <p>
                {{ t('HowIsPersonalInfoUtilizedContent') }}
            </p>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="3">
        <p-accordion-header>{{ t('IsPersonalInfoShared') }}</p-accordion-header>
        <p-accordion-content>
            <p>{{ t('IsPersonalInfoSharedContent') }}</p>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="4">
        <p-accordion-header>{{ t('HowIsPersonalInfoStored') }}</p-accordion-header>
        <p-accordion-content>
            <p>
                {{ t('HowIsPersonalInfoStoredContent') }}
            </p>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="5">
        <p-accordion-header>{{ t('RetentionPeriod') }}</p-accordion-header>
        <p-accordion-content>
            <p>
                {{ t('RetentionPeriodContent') }}
            </p>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="6">
        <p-accordion-header>{{ t('RequestDeletion') }}</p-accordion-header>
        <p-accordion-content>
            <p>
                {{ t('RequestDeletionContent') }}
                <a [href]="contactUsUrl">{{ t('ContactUs') }}</a>
                {{ t('RequestDeletionContent2') }}
            </p>
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>
